module.exports = __webpack_public_path__ + "img/shenfenzhengbeimian.9acaebdf.svg";